import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  inject,
} from '@angular/core';
import { ConnectedPosition } from '@angular/cdk/overlay';
import {
  NativePopupComponent,
  PresentationalAtomsModule,
} from '@et/presentational/atoms';

@Component({
  selector: 'et-pdf-viewer-header',
  imports: [PresentationalAtomsModule],
  templateUrl: './pdf-viewer-header.component.html',
  styleUrl: './pdf-viewer-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PdfViewerHeaderComponent implements AfterViewInit {
  private elementRef = inject(ElementRef);

  @Input({ required: true }) file!: File;
  @Input({ required: true }) totalPages!: number;
  @Input({ required: true }) page = 1;

  @Output() showOverlay = new EventEmitter<boolean>();
  @Output() changePage = new EventEmitter<number>();

  @ViewChild('advanceNavigation')
  advanceNavigation!: NativePopupComponent;

  width = 200;
  popupPosition: ConnectedPosition[] = [
    {
      originX: 'end',
      originY: 'bottom',
      overlayX: 'end',
      overlayY: 'top',
    },
  ];

  ngAfterViewInit(): void {
    this.getElementWidth();
  }

  /**
   * Opens navigation.
   *
   * This function emits a 'showOverlay' event with a value of true, and opens the advance navigation.
   */
  openNav() {
    this.showOverlay.emit(true);
    this.advanceNavigation.open();
  }

  /**
   * Gets the width of the element.
   *
   * This function gets the width of the element by calling the `getBoundingClientRect`
   * method on this. component, and assigns it to the `width` property.
   */
  private getElementWidth() {
    this.width = this.elementRef.nativeElement.getBoundingClientRect().width;
  }
}
